import { AxiosResponse } from 'axios';
import { awModelManagementApi } from '../Base';
import {
  AGraphComputeModelPerformancePayload,
  ComputeModelPerformanceResponse,
  ModelPerformanceLROResponse,
} from './types';

export const BASE_API_PATH = 'analytics/v1';

export function getLongRunningOperationsForId(id: string): Promise<AxiosResponse<ModelPerformanceLROResponse>> {
  const path = `${BASE_API_PATH}/longRunningOperations/${id}`;
  return awModelManagementApi.get(path);
}

export function postComputeModelPerformance(payload: AGraphComputeModelPerformancePayload) {
  const path = `${BASE_API_PATH}/models:computeModelPerformance`;
  return awModelManagementApi.post<ComputeModelPerformanceResponse>(path, payload);
}
